import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import NestedUserHeader from '../../component/reusable/NestedUserHeader';
import { getCategoryHeirarchy } from '../../redux/getCategoryHeirarchy';
import AddAdminForm from '../../component/adminComps/AddAdminForm';
import { exportCustomerThunk, getAllTypeCustomers } from '../../redux/customer/customerSlice';

const AddAdmin = () => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllTypeCustomers());
  }, []);

  return (
    <div >
      <NestedUserHeader 
        index="Add New Admin"
        root="admins"
        buttonText={'Back to list'}/>
      <AddAdminForm />
    </div>
  );

};

export default AddAdmin;
